import { useState } from 'react';
import { Button, Modal, Input } from 'tt-ui-lib/core';
import styles from './ResultDeleteModal.module.scss';

import { ReactComponent as CautionSvg } from '../../../../assets/svg/caution.svg';
import { Space } from 'antd';

const ResultDeleteModal = (props) => {
  const [inputValue, setInputValue] = useState(null);
  const { isDeleteModalOpened, closeDeleteModal, assessment, onDelete } = props;

  return (
    <Modal
      open={isDeleteModalOpened}
      onClose={closeDeleteModal}
      title={`Delete '${assessment?.name ?? ''}'`}
      className={styles.deleteModal}
      titleClassName={styles.title}
    >
      <Space direction="vertical" size={24} style={{ width: '100%', gap: 16, marginTop: 16 }}>
        <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <CautionSvg style={{ width: 40, height: 40, marginRight: 16 }} />
          <div style={{ color: 'red' }}>
            Are you sure you want to delete the calculator results? This action cannot be undone. If
            you continue, all data will be lost.
          </div>
        </Space>
        <div>Enter the calculator name to delete:</div>
        <Input
          label="Calculator name"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />

        <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button type="default" onClick={closeDeleteModal}>
            Cancel
          </Button>
          <Button type="primary" onClick={onDelete} disabled={inputValue !== assessment?.name}>
            Delete
          </Button>
        </Space>
      </Space>
    </Modal>
  );
};

export default ResultDeleteModal;
